import { render } from "./OsteopathieSection.vue?vue&type=template&id=8b6764bc&scoped=true"
import script from "./OsteopathieSection.vue?vue&type=script&lang=js"
export * from "./OsteopathieSection.vue?vue&type=script&lang=js"

import "./OsteopathieSection.vue?vue&type=style&index=0&id=8b6764bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6764bc"]])

export default __exports__